import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular'
import { TranslateService } from '@ngx-translate/core'
import firebase from 'firebase/app'
import { Storage } from '@ionic/storage'
import 'firebase/auth'
import { InAppBrowser } from '@ionic-native/in-app-browser'
import { LoginPage } from '../login/login';


@IonicPage()
@Component({
  selector: 'page-forgot',
  templateUrl: 'forgot.html',
})
export class ForgotPage {

  isSubmiting = false
  defaultLan
  email = ''

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public iab: InAppBrowser,
    public storage: Storage,
    public navParams: NavParams) {

      this.defaultLan = translate.getDefaultLang()
  }

  changeLanguage(lan) {
    this.translate.setDefaultLang(lan)
  }


  checkEmail() {
    return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(this.email)
  }


  forgot() {
    this.isSubmiting = true
    firebase.auth()
      .sendPasswordResetEmail(this.email)
      .then(() => {
        this.isSubmiting = false
        this.navCtrl.push(LoginPage,{}, {animation: 'wp-transition'})
        this.toastCtrl.create({
          message: this.translate.instant('successRestore'),
          duration: 3000
        }).present()
      }).catch(err => {
        console.log(err)
        this.isSubmiting = false
        this.toastCtrl.create({
          message: err.message,
          duration: 3000
        }).present()
      })
  }

  login() {
    this.navCtrl.push(LoginPage,{}, {animation: 'wp-transition'})
  } 

}



// WEBPACK FOOTER //
// ./src/pages/forgot/forgot.ts